import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { GeographicInfoState } from "@/Common/Models/Localization/GeographicInfoState";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CanadaState, CountryNames } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { PhoneNumberHelper } from "@/ContactDirectory/Helpers/PhoneNumberHelper";

export class PreferredPharmacyHelper {
    private patientAddresses: Address[];
    private currentEmployee: EmployeeUIModel;

    public constructor(patientAddresses: Address[], currentEmployee: EmployeeUIModel) {
        this.patientAddresses = patientAddresses;
        this.currentEmployee = currentEmployee;
    }

    public getCountryAndState(countryId?: string, stateId?: string): { country: GeographicInfoCountry, state: GeographicInfoState } {
        if (countryId) {
            return {
                country: cacheStore.CountryCacheById[countryId],
                state: cacheStore.StateCacheById[stateId] ?? null
            };
        }

        let preferredAddress = this.currentEmployee?.getActiveSite()?.getPreferredAddress();
        const patientPreferredAddress = this.patientAddresses?.firstPreferredOrDefault(p => p.IsPreferred);
        if (patientPreferredAddress?.CountryLookupId && patientPreferredAddress.StateLookupId)
            preferredAddress = patientPreferredAddress;

        if (preferredAddress?.CountryLookupId && preferredAddress.StateLookupId) {
            const country = cacheStore.getCountryByLookupId(preferredAddress.CountryLookupId);
            const state = cacheStore.getStateByLookupId(preferredAddress.StateLookupId);
            return { country: country, state: state };
        }

        console.error("Both patient and employee address is missing country or province.");
        const canadaLookupId = cacheStore
            .GetCountryLookups()
            .firstOrDefault(p => p.LookupCode === CountryNames.Canada)?.LookupID;
        const quebecLookupId = cacheStore.GetLookupIdForProvince(CanadaState.Quebec);
        return { country: cacheStore.getCountryByLookupId(canadaLookupId), state: cacheStore.getStateByLookupId(quebecLookupId) };
    }

    public formatPhoneNumber(phoneNumber: string, countryId?: string, stateId?: string): string {
        const { country, state } = this.getCountryAndState(countryId, stateId);
        return PhoneNumberHelper.format(phoneNumber, country?.Id, state?.Id);
    }
}
